import React from "react";
import swal from "sweetalert";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../../features/user/userSlice";
import { useState } from "react";
import { selectAuth } from "../../features/user/userSlice";
import { Chips } from "primereact/chips";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DeleteOutlined, Mail } from "@mui/icons-material";
import {
  Fab,
  CircularProgress,
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  ListItem,
  Chip,
  Typography,
  MenuItem,
} from "@mui/material";
import {
  useGetMailsQuery,
  useUpdateMailMutation,
  useCreateMailMutation,
  useDeleteMailMutation,
} from "../../features/api/apiYeapGo";
import { AutoAwesomeMotion, Sensors, SensorWindow } from "@mui/icons-material";
import axios from "axios";

export const Mails = () => {
  const Auth = useSelector(selectAuth);
  const { data, error, isLoading } = useGetMailsQuery({ Token: Auth });
  const user = useSelector(selectUser);
  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState();
  const [tags, setTags] = useState([]);
  const [updateMail] = useUpdateMailMutation();
  const [createMail] = useCreateMailMutation();
  const [deleteMail] = useDeleteMailMutation();
  let navigate = useNavigate();

  React.useEffect(() => {
    if (!user.Token) {
      navigate("login");
    } else if (user.Rol !== "Administrador") {
      swal("Sin permisos suficientes", "", "error");
      navigate("/");
    }
  }, [user]);

  const [dataTag, setDataTag] = useState({
    id: "",
    correo: "",
    nodos: [],
  });

  const handleClose = (action) => {
    setOpen(false);
    setDataTag({
      id: "",
      correo: "",
      nodos: [],
    });
    setTags([]);
    setUserId(0);
  };

  /* table columns */
  const columns = [
    {
      width: 20,
      sortable: false,
      renderCell: (params) => {
        const eliminarSensor = (e) => {
          e.stopPropagation();

          // Mostrar una alerta de confirmación antes de eliminar
          swal({
            title: "¿Estás seguro?",
            text: "Una vez eliminado, no podrás recuperar este elemento.",
            icon: "warning",
            buttons: {
              cancel: "Cancelar",
              confirm: "Eliminar",
            },
            dangerMode: true,
          }).then((willDelete) => {
            if (willDelete) {
              deleteMail({ Token: Auth, id: params.row.Id })
                .unwrap()
                .then(() => {
                  swal("Correo eliminado correctamente", "", "success");
                })
                .catch((error) => {
                  swal("Error al eliminar el correo", "", "error");
                });
            }
          });
        };

        return (
          <Button
            variant="text"
            color="secondary"
            startIcon={<DeleteOutlined />}
            onClick={eliminarSensor}
          ></Button>
        );
      },
    },
    {
      field: "Id",
      headerName: "ID",
      width: 70,
    },
    {
      field: "correo",
      headerName: "Correo",
      width: 200,
    },
    {
      field: "nodos",
      headerName: "Nodos",
      width: 400,
    },
  ];

  const gestionar = () => {
    const inputEmail = dataTag.correo;
    const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
      inputEmail
    );
    if (!isValidEmail) {
      swal("Correo invalido", "", "error");
      return;
    }

    if (!(dataTag.correo.length > 0 && dataTag.nodos.length > 0)) {
      swal("Deben llenarse todos los campos", "", "error");
    } else {
      if (dataTag?.id === "" || !dataTag.id) {
        if (data.filter((d) => d.correo === dataTag?.correo).length > 0) {
          swal("El correo ya ha sido añadido previamente", "", "error");
          return;
        }
        createMail({
          Token: Auth,
          body: {
            ...dataTag,
            nodos: dataTag.nodos.join(","),
          },
        })
          .unwrap()
          .then(() => {
            swal("Correo creado correctamente", "", "success");
            setOpen(false);
            /* Funcion para borrar */
            setDataTag({
              id: "",
              correo: "",
              nodos: [],
            });
            setTags([]);
          })
          .catch((e) => {
            swal("No se pudo crear el correo", "", "error");
          });
      } else {
        if (
          data.filter(
            (d) => d.correo === dataTag?.correo && d.Id !== dataTag.id
          ).length > 0
        ) {
          swal("El correo ya ha sido añadido previamente", "", "error");
          return;
        }
        updateMail({
          Token: Auth,
          id: dataTag.id,
          body: {
            ...dataTag,
            nodos: dataTag.nodos.join(","),
          },
        })
          .then(() => {
            swal("mensaje modificado correctamente", "", "success");
            setOpen(false);
            /* Funcion para borrar */
            setDataTag({
              id: "",
              correo: "",
              nodos: [],
            });
            setUserId(0);
            setTags([]);
          })
          .catch((e) => {
            swal("No se pudo modificar el mensaje", "", "error");
          });
      }
    }
  };

  return (
    <>
      <Grid
        item
        xs={12}
        md={9}
        sx={{
          height: 300,
          width: "100%",
        }}
      >
        {isLoading ? (
          <CircularProgress color="secondary" />
        ) : (
          <>
            <h2>Correos a notificar</h2>
            <DataGrid
              localeText={{
                noRowsLabel: "No se ha encontrado datos.",

                noResultsOverlayLabel: "No se ha encontrado ningún resultado",

                toolbarColumns: "Columnas",

                toolbarColumnsLabel: "Seleccionar columnas",

                toolbarDensity: "Densidad",

                toolbarDensityComfortable: "Comodo",

                toolbarDensityStandard: "Estandar",

                toolbarDensityCompact: "Compacto",

                toolbarFilters: "Filtros",

                toolbarFiltersLabel: "Ver filtros",

                toolbarFiltersTooltipHide: "Quitar filtros",

                toolbarFiltersTooltipShow: "Ver filtros",
              }}
              density={"compact"}
              autoHeight
              rows={data || []}
              pageSize={12}
              columns={columns}
              onRowClick={(e) => {
                setOpen(true);
                setDataTag({
                  ...e.row,
                  id: e.row.Id,
                  correo: e.row.correo,
                  nodos: e.row.nodos.split(","),
                });
                setUserId(e.row.Id);
              }}
              disableSelectionOnClick
              components={{ Toolbar: GridToolbar }}
              getRowId={(row) => row.Id}
            />
          </>
        )}
      </Grid>
      <Fab
        variant="extended"
        color="secondary"
        aria-label="gestionar"
        onClick={() => {
          setOpen(true);
        }}
        style={{
          margin: 0,
          right: 20,
          top: 100,
          left: "auto",
          position: "fixed",
        }}
      >
        Agregar Correo
      </Fab>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>
          <DialogTitle id="scroll-dialog-title">GESTIÓN DE CORREOS</DialogTitle>
        </DialogTitle>
        <DialogContent style={{ cursor: "pointer" }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "2%",
              }}
            >
              <TextField
                fullWidth
                required
                value={dataTag.correo}
                onChange={(e) =>
                  setDataTag({
                    ...dataTag,
                    correo: e.target.value,
                  })
                }
                label="Correo"
                InputProps={{
                  startAdornment: <Mail />,
                }}
                variant="outlined"
                type="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                select
                variant="outlined"
                label="Nodos*"
                SelectProps={{
                  multiple: true,
                }}
                value={dataTag?.nodos ?? []}
                onChange={(e) =>
                  setDataTag({
                    ...dataTag,
                    nodos: e.target.value,
                  })
                }
              >
                {["Interfaces", "Nodos", "Volumenes"]?.map((t) => {
                  return (
                    <MenuItem value={t} key={t}>
                      {t}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => gestionar()}
          >
            Aceptar
          </Button>
          <Button onClick={handleClose} color="secondary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
